import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { isRoutePublic } from 'src/router';
import { useFeatureFlagsContext } from 'src/contexts/FeatureFlagsContext';
import PageWrapper from '../PageWrapper';
import FullScreenLoader from '../FullScreenLoader';

type Props = {
  children: ReactNode;
};

function AppWrapper({ children }: Props) {
  const { pathname } = useLocation();
  const { authState } = useOktaAuth();
  const { loading: featuresLoading } = useFeatureFlagsContext();

  if (isRoutePublic(pathname)) {
    return <>{children}</>;
  }

  if (authState?.isAuthenticated) {
    if (featuresLoading) {
      // Features API in-flight: block the UI so nothing flickers in
      return <FullScreenLoader data-testid="app-wrapper" />;
    }
    return <PageWrapper data-testid="app-wrapper">{children}</PageWrapper>;
  }

  // Not yet authenticated: keep children mounted so Okta can process
  // its auth callbacks and transition authState to isAuthenticated
  return (
    <FullScreenLoader data-testid="app-wrapper">
      {children}
    </FullScreenLoader>
  );
}

export default AppWrapper;
